<template>
  <!-- <TabToggle :default-id="tabIndex" @onChange="onChangeTab" /> -->
  <van-config-provider style="height: 100%" :theme-vars="themeVars">
    <!-- <van-tabs v-model:active="active" > -->
    <van-tabs v-model:active="active" v-if="hash=='#/studentLeaveTeacher'">
      <van-tab title="老师代请">
        <Frame class="page-frame">
          <template v-slot:body>
            <div class="body">
              <van-cell-group inset>
                <van-field
                  v-if="userType == 'teacher'"
                  name="请假学生"
                  label="请假学生"
                  placeholder="请选择"
                  input-align="right"
                  v-model="studentInfo.name"
                  required
                  disabled
                  is-link
                  @click="navigateToObjSelect"
                />
                <van-field
                  v-if="userType != 'teacher'"
                  name="请假学生"
                  label="请假学生"
                  placeholder="学生姓名"
                  input-align="right"
                  v-model="studentInfo.name"
                  disabled
                  required
                />
                <van-field
                  v-model="leaveTypeName"
                  name="请假类型"
                  label="请假类型"
                  placeholder="请选择"
                  input-align="right"
                  disabled
                  required
                  is-link
                  @click="showPickerLeaveTypeEvt"
                />
              </van-cell-group>

              <van-cell-group inset>
                <van-field
                  name="开始时间"
                  label="开始时间"
                  placeholder="请选择"
                  input-align="right"
                  required
                  is-link
                  readonly
                  v-model="startDateTime"
                  @click="showPickerStartDateTimeEvt"
                />
                <van-field
                  name="结束时间"
                  label="结束时间"
                  placeholder="请选择"
                  input-align="right"
                  required
                  is-link
                  readonly
                  v-model="endDateTime"
                  @click="showPickerEndDateTimeEvt"
                />
                <van-field
                  name="请假时长"
                  label="请假时长"
                  placeholder="请假时长"
                  input-align="right"
                  readonly
                  disabled
                  v-model="timeRange"
                />
              </van-cell-group>
              <van-cell-group inset>
                <van-field
                  v-model="remark"
                  rows="3"
                  autosize
                  label=""
                  required
                  type="textarea"
                  maxlength="200"
                  style="line-height: 1.5; padding: 10px 15px"
                  placeholder="请输入请假原因（必填）"
                  show-word-limit
                />
                <ImageUpload :list="fileList" @change="imageUploadChange" />
              </van-cell-group>
            </div>
            <van-cell-group inset v-if="approveInfo.isExistApprove">
              <div class="process-header">
                <div class="title">审批流程</div>
                <div class="sub-title">依次审批</div>
              </div>
              <ProcessEdit
                ref="processRef"
                :list="approveInfo.approveList"
                @add-user="processAddUser"
              />
            </van-cell-group>
          </template>
          <template v-slot:footer>
            <div class="footer">
              <van-button
                class="van-button"
                type="primary"
                @click="addApplyServe"
                >提交</van-button
              >
            </div>
          </template>
        </Frame>
      </van-tab>
      <van-tab title="记录">
        <RecordListTeacher  />
      </van-tab>
    </van-tabs>
<Frame class="page-frame" v-if="hash=='#/studentLeaveParent'">
          <template v-slot:body>
            <div class="body">
              <van-cell-group inset>
                <van-field
                  v-if="userType == 'teacher'"
                  name="请假学生"
                  label="请假学生"
                  placeholder="请选择"
                  input-align="right"
                  v-model="studentInfo.name"
                  required
                  disabled
                  is-link
                  @click="navigateToObjSelect"
                />
                <van-field
                  v-if="userType != 'teacher'"
                  name="请假学生"
                  label="请假学生"
                  placeholder="学生姓名"
                  input-align="right"
                  v-model="studentInfo.name"
                  disabled
                  required
                />
                <van-field
                  v-model="leaveTypeName"
                  name="请假类型"
                  label="请假类型"
                  placeholder="请选择"
                  input-align="right"
                  disabled
                  required
                  is-link
                  @click="showPickerLeaveTypeEvt"
                />
              </van-cell-group>

              <van-cell-group inset>
                <van-field
                  name="开始时间"
                  label="开始时间"
                  placeholder="请选择"
                  input-align="right"
                  required
                  is-link
                  readonly
                  v-model="startDateTime"
                  @click="showPickerStartDateTimeEvt"
                />
                <van-field
                  name="结束时间"
                  label="结束时间"
                  placeholder="请选择"
                  input-align="right"
                  required
                  is-link
                  readonly
                  v-model="endDateTime"
                  @click="showPickerEndDateTimeEvt"
                />
                <van-field
                  name="请假时长"
                  label="请假时长"
                  placeholder="请假时长"
                  input-align="right"
                  readonly
                  disabled
                  v-model="timeRange"
                />
              </van-cell-group>
              <van-cell-group inset>
                <van-field
                  v-model="remark"
                  rows="3"
                  autosize
                  label=""
                  required
                  type="textarea"
                  maxlength="200"
                  style="line-height: 1.5; padding: 10px 15px"
                  placeholder="请输入请假原因（必填）"
                  show-word-limit
                />
                <ImageUpload :list="fileList" @change="imageUploadChange" />
              </van-cell-group>
            </div>
            <van-cell-group inset v-if="approveInfo.isExistApprove">
              <div class="process-header">
                <div class="title">审批流程</div>
                <div class="sub-title">依次审批</div>
              </div>
              <ProcessEdit
                ref="processRef"
                :list="approveInfo.approveList"
                @add-user="processAddUser"
              />
            </van-cell-group>
          </template>
          <template v-slot:footer>
            <div class="footer">
              <van-button
                class="van-button"
                type="primary"
                @click="addApplyServe"
                >提交</van-button
              >
            </div>
          </template>
        </Frame>
    <!-- <Frame class="page-frame">
        <template>
          <div>nnnnnnn </div>
        </template>
        <TabToggle :default-id="tabIndex" @onChange="onChangeTab" />
      </Frame> -->
    <van-popup v-model:show="showPickerApplicationDate" position="bottom">
      <van-picker
        :title="timerPickerTitle"
        :columns="dateTimeColumns"
        @confirm="onConfirmApplicationDate"
        @cancel="onCancleApplicationDate"
      />
    </van-popup>
    <van-popup v-model:show="showPickerLeaveType" position="bottom">
      <div class="visitor-type">
        <div class="header">
          <div class="left"></div>
          <div class="middle title">请假类型</div>
          <div class="right control" @click="showPickerLeaveType = false">
            取消
          </div>
        </div>
        <van-radio-group v-model="leaveTypeName">
          <van-cell-group inset>
            <van-cell
              clickable
              :title="item.name"
              :key="item.value"
              v-for="item in leaveTypeList"
              @click="onClickLeaveType(item)"
            >
              <template #right-icon>
                <van-radio :name="item.name">
                  <template #icon="props">
                    <van-image
                      class="img-icon"
                      width="18px"
                      height="18px"
                      :src="
                        props.checked
                          ? require('@/assets/image/common/checked.png')
                          : require('@/assets/image/common/un_checked.png')
                      "
                    />
                  </template>
                </van-radio>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
  </van-config-provider>
</template>

<script>
import Frame from "@/components/frame.vue";
import ImageUpload from "./imageUpload.vue";
import ProcessEdit from "@/components/process-edit/componemts/edit-item.vue";
import RecordListTeacher from "./recordListTeacher.vue";

import moment from "moment";
import Time from "@/utils/time.js";
// import mitt from 'mitt'
import { Toast, Tabs, Tab } from "vant";
import { ref, reactive, computed, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "StudentLeave",
  components: {
    Frame,
    ImageUpload,
    ProcessEdit,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    RecordListTeacher,

  },
  setup(props, { emit }) {
    const router = useRouter();
    console.log('----', window.location.hash)
    console.log('---$-', router.currentRoute.value.fullPath)
   const routerItem=window.location.hash;
   const start = routerItem.indexOf("#")
const end = routerItem.indexOf("?")
const hash = routerItem.slice(start,end)
   console.log("routerIndex",hash)
// str.slice（str.indexOf（“#”，str.indexOf（“？”））
    const active = ref(0);

    const themeVars = {
      navBarTextColor: "#333",
      navBarTextSize: "44px",
      cellGroupInsetPadding: "10px 0px",
      cellGroupInsetBorderRadius: 0,
      fieldLabelWidth: "150px",
      fieldWordLimitLineHeight: "36px",
      uploaderSize: "32px",
      uploaderIconSize: "20px",
      cellLineHeight: "54px",
      cellVerticalPadding: "0px",
      cellHorizontalPadding: "16px",
      popupBackgroundColor: "transparent"
    };
    const store = useStore();

    const BASE_FILE_URL = process.env.VUE_APP_BASE_File_URL;

    // const plateformType = computed(() => store.getters.plateformType);
    const userType = ref(computed(() => store.state.userType));
    // console.log("type",userType)
    // const userType = ref(computed(() => store.state.userType));

    const backupData = ref(computed(() => store.state.studentLeave.backupData));

    // 获取请假类型
    let leaveTypeList = ref([]);
    const leaveTypeListApi = params =>
      store.dispatch("studentLeave/leaveTypeList", params);
    const getLeaveTypeList = async () => {
      let r = await leaveTypeListApi();
      if (r.message == "success") {
        let list = r.data.list;
        list.map(item => {
          let temp = {
            name: item.typeName,
            value: item.typeId
          };
          leaveTypeList.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };
    getLeaveTypeList();

    const leaveType = ref(null || backupData.value.leaveType);
    const leaveTypeName = ref("" || backupData.value.leaveTypeName);
    const showPickerLeaveType = ref(false);
    const showPickerLeaveTypeEvt = () => {
      showPickerLeaveType.value = true;
    };
    const onClickLeaveType = item => {
      // onClickLeaveType.value = item.name
      leaveTypeName.value = item.name;
      leaveType.value = item;
      showPickerLeaveType.value = false;
      workflowConditionServe();
    };

    // 时间选择器类型
    const timerPickerTitle = ref("选择时间");
    const pickerTypeDateTime = ref(1);
    // 开始时间
    const startDateTime = ref("" || backupData.value.startDateTime);
    const showPickerStartDateTimeEvt = () => {
      pickerTypeDateTime.value = 1;
      timerPickerTitle.value = "开始时间";
      showPickerApplicationDate.value = true;
      workflowConditionServe();
    };
    // 结束时间
    const endDateTime = ref("" || backupData.value.endDateTime);
    const showPickerEndDateTimeEvt = () => {
      pickerTypeDateTime.value = 2;
      timerPickerTitle.value = "结束时间";
      showPickerApplicationDate.value = true;
      workflowConditionServe();
    };
    // 时长
    const timeRangeHours = computed(() => {
      if (!startDateTime.value || !endDateTime.value) return 0;
      // let startTime = startDateTime.value.replace(/-/g, "/");
      // let endTime = endDateTime.value.replace(/-/g, "/");
      // let time = (new Date(endTime) - new Date(startTime)) / 60 / 60 / 1000;
      const startTime = moment(startDateTime.value);
      const endTime = moment(endDateTime.value);
      const time = endTime.diff(startTime, "hours");
      return time;
    });

    const timeRange = computed(() => {
      let day = Math.floor(timeRangeHours.value / 24);
      let h = Math.ceil(timeRangeHours.value - day * 24);
      return `${day ? day + "天" : ""}${h ? h + "小时" : ""}`;
    });

    // 时间选择器显示隐藏
    const showPickerApplicationDate = ref(false);
    const onConfirmApplicationDate = values => {
      let [date, h, m] = values;
      if (pickerTypeDateTime.value == 1) {
        startDateTime.value = `${date} ${h}:${m}`;
      } else {
        endDateTime.value = `${date} ${h}:${m}`;
      }
      showPickerApplicationDate.value = false;
    };
    const onCancleApplicationDate = () => {
      showPickerApplicationDate.value = false;
    };

    const formatTimeColumns = () => {
      let dateArr = [];
      for (let i = 0; i < 60; i++) {
        let curDateTime = new Date().getTime() + 24 * 60 * 60 * 1000 * i;
        let curDate = Time.formatDate(new Date(curDateTime));
        dateArr.push(curDate);
      }

      let hArr = [];
      for (let i = 0; i < 24; i++) {
        let h = "";
        if (i <= 9) {
          h = "0" + i;
        } else {
          h = i + "";
        }
        hArr.push(h);
      }

      let mArr = [];
      for (let i = 0; i < 60; i++) {
        let m = "";
        if (i <= 9) {
          m = "0" + i;
        } else {
          m = i + "";
        }
        mArr.push(m);
      }

      return [
        {
          values: dateArr,
          defaultIndex: 1
        },
        {
          values: hArr,
          defaultIndex: new Date().getHours()
        },
        {
          values: mArr,
          defaultIndex: new Date().getMinutes()
        }
      ];
    };
    const dateTimeColumns = reactive(formatTimeColumns());

    // 请假学生
    const studentName = computed(() => store.state.studentName);
    const studentUserIndex = computed(() => store.state.studentUserIndex);
    const classId = computed(() => store.state.classId);
    const studentUserId = computed(() => store.state.studentUserId);
    console.log("学生信息", classId);
    console.log("studentGradeId", studentInfo);
    const studentInfo = ref({});
    if (userType.value !== "teacher") {
      studentInfo.value = {
        name: studentName.value,
        userIndex: studentUserIndex.value,
        userId: studentUserId.value,
        classId: classId.value
      };
    } else {
      studentInfo.value = backupData.value.studentInfo;
    }
    const navigateToObjSelect = () => {
      router.push({
        path: "/studentSelect",
        query: {
          moduleName: "studentLeave",
          sourceType: "S",
          resType: "user",
          checkType: "single",
          defaultList: [studentInfo.value.userIndex]
        }
      });
      workflowConditionServe();
    };
    let processAddIndex = backupData.value.processAddIndex || 0;
    const navigateToObjSelectProcess = (
      checkType,
      limit,
      limitRange,
      defaultList
    ) => {
      router.push({
        path: "/studentSelect",
        query: {
          moduleName: "process",
          sourceType: "T",
          resType: "user",
          checkType,
          limit,
          limitRange,
          defaultList
        }
      });
    };
    const processAddUser = (cb, i) => {
      processAddIndex = i;
      let { chooseNumber, chooseRange, chooseUserList, selectedUserList } =
        approveInfo.value.approveList[processAddIndex];
      let checkType = chooseNumber == "one" ? "single" : "multiple";
      let limit = chooseRange === "limited";
      let limitRange = [];
      chooseUserList.map(user => {
        limitRange.push(user.userIndex);
      });
      let defaultList = [];
      selectedUserList.map(user => {
        defaultList.push(user.userIndex);
      });
      navigateToObjSelectProcess(checkType, limit, limitRange, defaultList);
    };
    const persionSelectedPage = computed(() => store.state.persionSelectedPage);
    // const gradeId=store.state.persionSelectedPage.gradeId
    // 审批流获取
    const approveInfo = ref(backupData.value.approveInfo);
    const bizType = window.sessionStorage.getItem("bizType");
    console.log("bizType", bizType);
    const workflowCondition = params =>
      store.dispatch("studentLeave/workflowCondition", params);
    const workflowConditionServe = async () => {
      if (!leaveType.value || !leaveType.value.value) return;
      //  const bizType = window.sessionStorage.getItem('bizType')
      //  const key = bizType === 'student_leave' ? 'studentLeaveList' : bizType == 'teacher_attendance' ? 'teacherAttendanceList' : bizType === 'teacher_leave' ? 'teacherLeaveList' : ''
      const { data: arr } = store.state.persionSelectedPage;
      const classIdForTeacher = arr[0] ? arr[0].gradeId : "";
      let params = {
        bizType: "student_leave",
        studentLeave: {
          dictionaryId: leaveType.value.value,
          duration: timeRangeHours.value,
          unit: "hour",
          classId:
            userType.value === "teacher" ? classIdForTeacher : classId.value
        }
      };
      console.log("params=====", params);
      let r = await workflowCondition(params);
      let { success, data, message } = r;
      if (!success) {
        Toast.fail(message);
      } else {
        approveInfo.value = data;
        console.log("审批流", data);
      }
      // approveInfo.value = {
      //   isExistApprove: true,
      //   flowCode: "student_leave_flow_20220116123527",
      //   flowName: "默认审批流",
      //   approveList: [
      //     {
      //       flowType: "approve",
      //       flowLevel: 1,
      //       approveType: "single",
      //       rangeType: "customize",
      //       chooseRange: "all",
      //       isOperate: true,
      //       selectedUserList: [],
      //       chooseNumber: "one",
      //       chooseUserList: [],
      //     },
      //     {
      //       flowType: "cc",
      //       flowLevel: 2,
      //       approveType: "",
      //       rangeType: "",
      //       chooseRange: "all",
      //       isOperate: true,
      //       selectedUserList: [],
      //       chooseNumber: "more",
      //       chooseUserList: [],
      //     },
      //   ],
      // };
    };
    watch([leaveType, timeRangeHours], ([leaveType, timeRangeHours]) => {
      if (leaveType && timeRangeHours) {
        workflowConditionServe();
      }
    });
    watch(
      persionSelectedPage,
      persionSelectedPage => {
        let { moduleName, data } = persionSelectedPage;
        if (data && data.length) {
          if (moduleName == "studentLeave") {
            studentInfo.value = data[0];
          }
          if (moduleName == "process") {
            data.map(user => {
              user.userName = user.name;
            });
            approveInfo.value.approveList[processAddIndex].selectedUserList = [
              ...data
            ];
          }
        } else {
          if (moduleName == "studentLeave") {
            studentInfo.value = {};
          }
          if (moduleName == "process") {
            approveInfo.value.approveList[processAddIndex].selectedUserList =
              [];
          }
        }
      },
      {
        immediate: true
      }
    );

    // 备注
    const remark = ref("" || backupData.value.remark);

    const fileList = ref(backupData.value.fileList);
    const imageUploadChange = fileListCom => {
      fileList.value = fileListCom;
    };

    // 审批流
    const addApply = params => store.dispatch("studentLeave/addApply", params);
    const addApplyServe = async () => {
      if (!leaveType.value || !leaveType.value.value) {
        Toast.fail("请先选择请假类型！");
        return;
      }

      if (!startDateTime.value) {
        Toast.fail("请先选择开始时间！");
        return;
      }

      if (!endDateTime.value) {
        Toast.fail("请先选择结束时间！");
        return;
      }

      if (Number(timeRange.value) <= 0) {
        Toast.fail("请结束时间要大于开始时间！");
        return;
      }

      if (!remark.value) {
        Toast.fail("请输入请假理由！");
        return;
      }

      let fileIdList = [];
      if (fileList.value && fileList.value.length) {
        fileList.value.map(item => {
          fileIdList.push(item.id);
        });
      }

      approveInfo.value.bizType = "student_leave";
      approveInfo.value.isExistApprove = true;
      let params = {
        approveParam: approveInfo.value,
        fileIdList: fileIdList,
        duration: timeRange.value, // 展示带单位
        hour: timeRangeHours.value,
        leaveTypeId: leaveType.value.value,
        leaveTypeName: leaveType.value.name,
        reason: remark.value,
        startTime: startDateTime.value ? startDateTime.value + ":00" : "",
        endTime: endDateTime.value ? endDateTime.value + ":00" : "",
        studentName: studentInfo.value.name,
        studentUserId: studentInfo.value.userId,
        studentUserIndex: studentInfo.value.userIndex,
        studentGradeId: studentInfo.value.gradeId
      };
      console.log("mmmmmmmmmmmmmm", studentInfo);
      let r = await addApply(params);
      if (r.message == "success") {
        // 清空store里的数据
        store.commit("resetBackupData");
        if (userType.value === "teacher") {
          goHome();
        } else {
          emit("history");
        }
      } else {
        Toast.fail(r.message);
      }
    };

    const goHome = () => {
      // let url = "";
      // if (plateformType.value == "DingTalkMini") {
      //   url = "pages/index/index";
      // } else {
      //   url = "pages/index/index";
      // }
      /* eslint-disable */
      uni.navigateBack({
        delta: 1
      });
      /* eslint-disable */
    };

    // 跳转选人组件卸载页面前把数据缓存到store
    onBeforeUnmount(() => {
      let backupData = {
        studentInfo: studentInfo.value,
        leaveType: leaveType.value,
        leaveTypeName: leaveTypeName.value,
        startDateTime: startDateTime.value,
        endDateTime: endDateTime.value,
        approveInfo: approveInfo.value,
        remark: remark.value,
        fileList: fileList.value,
        processAddIndex: processAddIndex
      };
      store.commit("studentLeave/setBackupData", backupData);
    });

    return {
      active,
      routerItem,
      start,
      end,
      hash,
      useRouter,
      themeVars,
      BASE_FILE_URL,
      userType,
      leaveTypeList,
      studentInfo,
      navigateToObjSelect,
      leaveType,
      leaveTypeName,
      showPickerLeaveType,
      showPickerLeaveTypeEvt,
      onClickLeaveType,
      timerPickerTitle,
      startDateTime,
      showPickerStartDateTimeEvt,
      endDateTime,
      showPickerEndDateTimeEvt,
      timeRange,
      showPickerApplicationDate,
      onConfirmApplicationDate,
      onCancleApplicationDate,
      dateTimeColumns,
      openSave: params => store.dispatch("visitor/openSave", params),
      openChange: params => store.dispatch("visitor/openChange", params),
      fileList,
      imageUploadChange,
      remark,
      addApplyServe,
      persionSelectedPage,
      processAddUser,
      approveInfo
    };
  }
};
</script>

<style lang="less" scoped>
.page-frame {
  height: 100%;
  background-color: #f2f4f9;
}
.list {
  height: 2000px;
  background-color: #f00;
}
h1 {
  height: 44px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin: 0;
}
.footer {
  width: 100%;
  background-color: #fff;
  text-align: center;
  .van-button {
    width: 345px;
    height: 36px;
    background: #4174fd;
    border-radius: 18px;
    margin: 6px auto;
  }
}
.visitor-type {
  border-radius: 8px 8px 0px 0px;
  background-color: #fff;
  overflow: hidden;
  .header {
    display: flex;
    height: 54px;
    align-items: center;
    padding: 0 16px;
    .left,
    .middle,
    .right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title {
      color: #333;
      font-size: 17px;
      font-weight: 500;
    }
    .control {
      color: #333;
      font-size: 15px;
      font-weight: 400;
      justify-content: flex-end;
    }
  }
}

.search-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vw;
  z-index: 100;
}

.jy-uploader {
  height: 100%;
  display: flex;
  align-items: center;
}

.process-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
  font-size: 15px;
  font-weight: 400;
  margin: 16px 15px;
  .sub-title {
    color: #999;
    font-size: 13px;
  }
}

/deep/ .van-field__label {
  color: #333;
}
/deep/ .van-field__body input {
  text-align: right;
}
</style>
